import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import TenantTopNav from './Layout/Nav/TenantTopNav';
import TenantAppAccordian from './Layout/Nav/TenantAppAccordian';
import SignInPageRoutes from './SignInPageRoutes';
import utils from '../utils';
import CONSTANTS from '../constants';

// Keeps TenantTopNav and SignInPageRoutes mounted across the lg/sm breakpoint
// so a window resize only swaps the nav shell, not the whole routed page tree.
function PrtLandPage({
    tenantSettings,
    accounts,
    notifications,
    apiError,
    tooltip,
    showNav,
    setShowNav,
    windowSize,
    curNav,
    firstTimeUser,
    accessToken,
    isAuthenticated,
    queryRequest,
    supportModalShown,
    onQuery,
    setSupportModalIsShown,
    getNewScreenWidth,
    resetToken,
    showNavHandler,
    onLinkClick,
    userAppsList
}) {
    const isLargeView = windowSize > 992;

    const sidebarApps = (() => {
        const apps = tenantSettings?.tenant?.fields?.apps;
        if (!apps) return null;
        const filtered = utils.returnNeededApps(apps, CONSTANTS.APPS_TO_HIDE);
        if (userAppsList === null) return null;
        return filtered.filter(app => utils.appAllowedForUser(app, userAppsList));
    })();

    return (
        <>
            <TenantTopNav
                className={showNav ? 'show' : 'hide'}
                tenant={tenantSettings && tenantSettings.tenant ? tenantSettings.tenant : null}
                onQuery={onQuery}
                raiseSupport={setSupportModalIsShown}
                onWidthChange={getNewScreenWidth}
                windowSize={windowSize}
                tenantName={
                    tenantSettings &&
                        tenantSettings.tenant &&
                        tenantSettings.tenant.fields &&
                        tenantSettings.tenant.fields.tenantSlug ?
                        tenantSettings.tenant.fields.tenantslug : ''}
                resetToken={resetToken}
                showFakes={firstTimeUser}
            />
            <Row className='content-row'>
                {
                    isLargeView ?
                        <Col
                            className={showNav ?
                                    'side-workspace-nav show'
                                    : 'side-workspace-nav hide'}>
                                <div className='nav-container'>
                                    <TenantAppAccordian
                                        tenantSlug={tenantSettings && tenantSettings.tenant && tenantSettings.tenant.fields && tenantSettings.tenant.fields.tenantslug}
                                        tenantApps={sidebarApps}
                                        raiseSupport={setSupportModalIsShown}
                                        sa={
                                            tenantSettings &&
                                                tenantSettings.tenant &&
                                                tenantSettings.tenant.fields &&
                                                tenantSettings.tenant.fields.sa ?
                                                tenantSettings.tenant.fields.sa
                                                : ''
                                        }
                                        tenant={tenantSettings}
                                        show={showNav}
                                        showNavHandler={showNavHandler}
                                        screenSize={'large'}
                                        onLinkClick={onLinkClick}
                                    />
                                </div>
                        </Col>
                    :
                        <Col md={12} onClick={() => setShowNav(!showNav)} className={showNav ? 'top-workspace-nav show' : 'top-workspace-nav hide'}>
                            <TenantAppAccordian
                                tenantApps={sidebarApps}
                                raiseSupport={setSupportModalIsShown}
                                show={showNav}
                                tenant={tenantSettings}
                                showNavHandler={showNavHandler}
                                screenSize='small'
                                onLinkClick={onLinkClick}
                                showFakes={firstTimeUser}
                            />
                        </Col>
                }
                <Col>
                    <Container fluid className={showNav ? "profiles-page body-container show" : "profiles-page body-container hide"}>
                        <Col>
                            <SignInPageRoutes
                                tenantSettings={tenantSettings}
                                accounts={accounts}
                                notifications={notifications}
                                apiError={apiError}
                                tooltip={tooltip}
                                showNav={showNav}
                                windowSize={windowSize}
                                curNav={curNav}
                                firstTimeUser={firstTimeUser}
                                accessToken={accessToken}
                                isAuthenticated={isAuthenticated}
                                queryRequest={queryRequest}
                                supportModalShown={supportModalShown}
                                userAppsList={userAppsList}
                            />
                        </Col>
                    </Container>
                </Col>
            </Row>
        </>
    );
}

export default PrtLandPage;
